import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormatter',
  pure: false
})
export class DateFormatterPipe implements PipeTransform {
  
  transform(serializedDate?: Date): any {
    return this.formatBackendDate(serializedDate);
  }

  formatBackendDate(dateVal?: Date) {
    if (!dateVal) { return ''; }
    var date = new Date(dateVal);
    //console.log('Serialized: ' + serializedDate + ', Date: ' + date.toDateString());

    //if (isNaN(date.getTime())) {
    //  return 'invalid date format';
    //}
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return (
      (month < 10 ? '0' + month : month) +
      '/' +
      (day < 10 ? '0' + day : day) +
      '/' +
      year
    );

    //let hours = date.getHours();
    //let AMOrPM = 'AM';
    //if (hours >= 12) {
    //  AMOrPM = 'PM';
    //  hours = hours - 12;
    //}
    //if (hours === 0) {
    //  hours = 12;
    //}
    //const minutes = date.getMinutes();
    //const seconds = date.getSeconds();
    //return (
    //  (month < 10 ? '0' + month : month) +
    //  '/' +
    //  (day < 10 ? '0' + day : day) +
    //  '/' +
    //  year +
    //  '  ' +
    //  (hours < 10 ? '0' + hours : hours) +
    //  ':' +
    //  (minutes < 10 ? '0' + minutes : minutes) +
    //  (includeSecs === true ? (seconds < 10 ? ':0' + seconds : ':' + seconds) : '') +
    //  ' ' +
    //  AMOrPM
    //);
  }
}
